export { default } from './AssignedUser';
